import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const AuthServices = {
  // Define your API functions here

  login: async (data) => {
    const response = await apiService.post(`/customers/login`, data);
      console.log("response",response);
    return response.data;
  },
  register: async (data) => {
    const response = await apiService.post(`/customers/signup`, data);
    return response.data;
  },
  getRoles: async () => {
    const response = await apiService.get(`/auth/roles`);
    return response.data;
  },
  verify: async (data) => {
    const response = await apiService.post("/customers/activate", data);
    return response.data;
  },

  resend: async (id) => {
    const response = await apiService.get(`/customers/${id}/resend-code`);
    return response.data;
  },
  refresh: async (data) => {
    const response = await apiService.post("/refresh", data);
    return response.data;
  },
  update: async (id,data) => {
    const response = await apiService.patch(`/customers/${id}`, data);
    return response.data;
  },
};

export default AuthServices;
